import React, { useState } from 'react';
import {
  Box, Container, Card, CardBody, VStack, Heading, Text, FormControl, FormLabel,
  Input, Button, Alert, AlertIcon, Link, Image,
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import logoVertical from '../assets/logo/aplica-ia-logo-vertical.svg';
import { authApi } from '../services/api';

// Página de redefinição de senha — acessada pelo link enviado por e-mail.
const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) { setError('A nova senha deve ter no mínimo 8 caracteres.'); return; }
    if (pw !== confirm) { setError('As senhas não conferem.'); return; }
    setLoading(true);
    try {
      await authApi.resetPassword(token, pw);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Não foi possível redefinir a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box bg="gray.50" minH="100vh" display="flex" alignItems="center">
      <Container maxW="md">
        <Card>
          <CardBody>
            <VStack spacing={5} align="stretch">
              <Image src={logoVertical} alt="Aplica IA" h="56px" objectFit="contain" alignSelf="center" />
              <Heading size="md" textAlign="center" color="brand.700">Redefinir senha</Heading>

              {!token ? (
                <Alert status="error" borderRadius="md"><AlertIcon />Link inválido. Solicite a redefinição novamente na tela de login.</Alert>
              ) : done ? (
                <Alert status="success" borderRadius="md"><AlertIcon />Senha redefinida! Redirecionando para o login...</Alert>
              ) : (
                <form onSubmit={submit}>
                  <VStack spacing={4} align="stretch">
                    {error && <Alert status="error" borderRadius="md"><AlertIcon />{error}</Alert>}
                    <FormControl isRequired>
                      <FormLabel fontSize="sm">Nova senha</FormLabel>
                      <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Mínimo 8 caracteres" autoComplete="new-password" autoFocus />
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel fontSize="sm">Confirmar nova senha</FormLabel>
                      <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
                    </FormControl>
                    <Button type="submit" colorScheme="brand" width="100%" isLoading={loading}>Redefinir senha</Button>
                  </VStack>
                </form>
              )}

              <Text fontSize="sm" textAlign="center" color="gray.500">
                <Link as={RouterLink} to="/login" color="brand.600">Voltar para o login</Link>
              </Text>
            </VStack>
          </CardBody>
        </Card>
      </Container>
    </Box>
  );
};

export default ResetPassword;
